<template>
  <div class="product">
    <div v-for="item in lists" :key="item.id">
      <v-card :card="item" @handleClick="handleClick"></v-card>
    </div>
  </div>
</template>

<script>
import vCard from '@/components/product-card'
import axios from 'axios'

export default {
  components: {
    vCard,
  },
  data () {
    return {
      lists: [],
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      axios.get('../../../../data-list.json').then(res => {
        this.lists= res.data
      })
    },
    handleClick (card) {
      this.$router.push(`/product/detail/${card.id}`)
    }
  },
}
</script>

<style lang="scss" scoped>
.product {
  overflow: hidden;
  margin: 0 auto;
  width: 1160px;
  padding: 50px 0 47px 0;
}
</style>